import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";

/**
 * Password input with an inline show/hide toggle.
 *
 * Defaults to hidden (type="password"). Clicking the eye icon reveals the
 * value in clear text (type="text"). Accepts every prop supported by
 * <Input>; the `type` prop is intentionally ignored.
 */
export function PasswordInput({ className = "", ...props }) {
  const [visible, setVisible] = useState(false);
  const testId = props["data-testid"];
  return (
    <div className="relative">
      <Input
        {...props}
        type={visible ? "text" : "password"}
        className={`pr-11 ${className}`}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Hide password" : "Show password"}
        data-testid={testId ? `${testId}-toggle` : undefined}
        className="absolute inset-y-0 right-0 flex items-center pr-3 text-muted-foreground hover:text-foreground transition-colors focus:outline-none"
        tabIndex={-1}
      >
        {visible ? <EyeOff size={18} strokeWidth={1.75} /> : <Eye size={18} strokeWidth={1.75} />}
      </button>
    </div>
  );
}
